import React, {useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import InputEx from "../../../components/wrapperComponents/InputEx";
import RadioInput from "../../../components/RadioInput";
import EmailButton from "../../../components/EmailButton";
import TelefonoButton from "../../../components/TelefonoButton";
import FaxButton from "../../../components/FaxButton";
import EditButton from "../../../components/EditButton";
import {AziendaEditorProps} from "../Azienda.generalita.page";
import CheckboxEx from "../../../components/wrapperComponents/CheckboxEx";
import {ProvinciaRecord} from "@commons/mapping/ProvinciaRecord";
import {ComuneRecord} from "@commons/mapping/ComuneRecord";
import FormButtons from "../../../components/FormButtons";
import ComboBoxProvince from "../../../components/comboBox/ComboBoxProvince";
import ComboBoxComuni from "../../../components/comboBox/ComboBoxComuni";

const GeneralitaAziendaEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {

    const initialValues: AziendaRecord = useMemo(() => {
        let comuneDomAmm;
        {
            const origine = (resource && resource.domAmm) ? resource.domAmm : defaultValues.domAmm;
            comuneDomAmm = ComuneRecord.factory({
                codComune: origine.comuneCodCatasto,
                siglaProv: origine.provinciaSigla,
                descrizione: origine.comuneDescrizione,
                cap: origine.cap,
            });
        }
        let comuneSedeLegale;
        {
            const origine = (resource && resource.sedeLegale) ? resource.sedeLegale : defaultValues.sedeLegale;
            comuneSedeLegale = ComuneRecord.factory({
                codComune: origine.comuneCodCatasto,
                siglaProv: origine.provinciaSigla,
                descrizione: origine.comuneDescrizione,
                cap: origine.cap,
            });
        }
        if (!resource)
            console.warn("Inizializzo azienda! NULL/UNDEFINED");
        else
            console.log("Inizializzo azienda!");
        return {
            ...defaultValues, ...resource,
            domAmm: {...resource.domAmm, comune: comuneDomAmm},
            sedeLegale: {...resource.sedeLegale, comune: comuneSedeLegale},
        };
    }, [resource, defaultValues]);

    const [codAziendaReadOnly, setCodAziendaReadOnly] = useState(true);
    const [codULReadOnly, setCodULReadOnly] = useState(true);
    const toggle = (readOnly: boolean) => !readOnly;

    // https://stackoverflow.com/questions/62242657/how-to-change-react-hook-form-defaultvalue-with-useeffect
    const {watch, register, getValues, setValue, handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();
    useEffect(() => {
        reset(initialValues);
    }, [resource]);

    const comuneDomAmm: ComuneRecord | null | undefined = watch('domAmm.comune');
    useEffect(() => {
        if (comuneDomAmm && comuneDomAmm.descrizione) {
            setValue('domAmm.comuneDescrizione', comuneDomAmm.descrizione);
            setValue('domAmm.comuneCodCatasto', comuneDomAmm.codComune);
            setValue('domAmm.cap', comuneDomAmm.cap);
        } else {
            setValue('domAmm.comuneDescrizione', null);
            setValue('domAmm.comuneCodCatasto', null);
            setValue('domAmm.cap', null);
        }
    }, [comuneDomAmm, setValue]);

    const comuneSedeLegale: ComuneRecord | null | undefined = watch('sedeLegale.comune');
    useEffect(() => {
        if (comuneSedeLegale && comuneSedeLegale.descrizione) {
            setValue('sedeLegale.comuneDescrizione', comuneSedeLegale.descrizione);
            setValue('sedeLegale.comuneCodCatasto', comuneSedeLegale.codComune);
            setValue('sedeLegale.cap', comuneSedeLegale.cap);
        } else {
            setValue('sedeLegale.comuneDescrizione', null);
            setValue('sedeLegale.comuneCodCatasto', null);
            setValue('sedeLegale.cap', null);
        }
    }, [comuneSedeLegale, setValue]);
    const resetProvinciaDomAmm = (prov: ProvinciaRecord | null) => {
        setValue('domAmm.comune', null);
    }
    const resetProvinciaSedeLegale = (prov: ProvinciaRecord | null) => {
        setValue('sedeLegale.comune', null);
    }

    function onHandleSubmit(newValues: AziendaRecord) {
        onSubmit({
            ...newValues,
            domAmm: {...newValues.domAmm, comune: undefined},
            sedeLegale: {...newValues.sedeLegale, comune: undefined},
        })
    }

    return <>

        <form className="p-1" onSubmit={handleSubmit(onHandleSubmit)}>

            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <InputEx
                        label="Codice"
                        name="codAzienda"
                        register={register}
                        addOnAfter={<EditButton onClick={() => setCodAziendaReadOnly(toggle)}/>}
                        readOnly={codAziendaReadOnly}
                    />
                </div>
                <div className="sm4-6P">
                    <InputEx
                        label="Denominazione"
                        name="denominazione"
                        register={register}
                    />
                </div>
            </div>
            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <InputEx
                        label="Codice UL"
                        name="codFiliale"
                        register={register}
                        addOnAfter={<EditButton onClick={() => setCodULReadOnly(toggle)}/>}
                        readOnly={codULReadOnly}
                    />
                </div>
                <div className="sm4-6P">
                    <InputEx
                        label="Descrizione azienda/UL"
                        name="unitaLocale"
                        register={register}
                    />
                </div>
            </div>
            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <label htmlFor="tipo_soggetto" className="block font-medium text-sm">Tipo soggetto</label>

                    <RadioInput
                        label="Ditta individuale"
                        className="mt-2"
                        value="DITTA_INDIVIDUALE"
                        name="personaFisica"
                        id="tipo_ditta"
                        register={register}
                        disabled={!AziendaRecord.isMaster(resource)}
                    />
                    <RadioInput
                        label="Azienda"
                        value="AZIENDA"
                        name="personaFisica"
                        id="tipo_azienda"
                        register={register}
                        disabled={!AziendaRecord.isMaster(resource)}
                    />
                    <RadioInput
                        label="Privato"
                        value="PRIVATO"
                        name="personaFisica"
                        id="tipo_privato"
                        register={register}
                        disabled={!AziendaRecord.isMaster(resource)}
                    />
                </div>
                <div className="sm2-6P">
                    <InputEx
                        label="Codice fiscale"
                        name="codiceFiscale"
                        register={register}
                    />
                </div>
                <div className="sm2-6P">
                    <InputEx
                        label="P. IVA"
                        name="partitaIva"
                        register={register}
                        disabled={watch('personaFisica') === 'PRIVATO'}
                    />
                </div>
            </div>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Domicilio amministrativo</legend>

                <div className="flexRowWrapFull !mt-0">
                    <div className="sm2-6P">
                        <ComboBoxProvince control={control} name="domAmm.provinciaSigla" defaultValue={initialValues.domAmm.provinciaSigla} onChange={resetProvinciaDomAmm}/>
                    </div>

                    <div className="sm2-6P">
                        <ComboBoxComuni control={control} name="domAmm.comune" defaultValue={initialValues.domAmm.comune!} siglaProv={watch('domAmm.provinciaSigla')}/>
                    </div>

                    <div className="flexRowWrap sm2-6P mt-0">
                        <div className="sm1-2P">
                            <InputEx
                                label="Cod. ComuneRecord"
                                name="domAmm.comuneCodCatasto"
                                register={register}
                                readOnly
                            />
                        </div>
                        <div className="sm1-2P">
                            <InputEx
                                label="CAP"
                                addOnBefore={<CheckboxEx control={control} name="domAmm.multiCap" className="h-full min-w-[30px] max-w-[30px]"/>}
                                name="domAmm.cap"
                                register={register}
                                readOnly={!watch('domAmm.multiCap')}
                            />
                        </div>
                    </div>

                </div>
                <div className="flexRowWrapFull">
                    <div className="sm4-6P">
                        <InputEx
                            label="Invirizzo: Piazza / Via"
                            name="domAmm.indirizzoVia"
                            register={register}
                        />
                    </div>
                    <div className="sm1-6P">
                        <InputEx
                            label="Num. Civico"
                            name="domAmm.indirizzoNumero"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm4-6P">
                        <InputEx
                            label="Invirizzo: altre indicazioni"
                            name="domAmm.indirizzoVia2"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm2-6P">
                        <InputEx
                            label="Telefono"
                            name="domAmm.telefono"
                            register={register}
                            addOnBefore={<TelefonoButton telefono={resource.domAmm.telefono}/>}
                        />

                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Fax"
                            name="domAmm.fax"
                            register={register}
                            addOnBefore={<FaxButton fax={resource.domAmm.fax}/>}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            type="email"
                            label="Email"
                            name="domAmm.email"
                            register={register}
                            addOnBefore={<EmailButton email={resource.domAmm.email}/>}
                        />
                    </div>
                </div>

            </fieldset>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Sede legale</legend>

                <div className="flexRowWrapFull">

                    <div className="sm2-6P">
                        <ComboBoxProvince control={control} name="sedeLegale.provinciaSigla" defaultValue={initialValues.sedeLegale.provinciaSigla}
                                          onChange={resetProvinciaSedeLegale}/>
                    </div>

                    <div className="sm2-6P">
                        <ComboBoxComuni control={control} name="sedeLegale.comune" defaultValue={initialValues.sedeLegale.comune!} siglaProv={watch('sedeLegale.provinciaSigla')}/>
                    </div>

                    <div className="flexRowWrap sm2-6P mt-0">
                        <div className="sm1-2P">
                            <InputEx
                                label="Cod. ComuneRecord"
                                name="sedeLegale.comuneCodCatasto"
                                register={register}
                                readOnly
                            />
                        </div>
                        <div className="sm1-2P">
                            <InputEx
                                label="CAP"
                                name="sedeLegale.cap"
                                register={register}
                                addOnBefore={<CheckboxEx control={control} name="sedeLegale.multiCap" className=""/>}
                                readOnly={!watch('sedeLegale.multiCap')}
                            />
                        </div>
                    </div>

                </div>
                <div className="flexRowWrapFull">
                    <div className="sm4-6P">
                        <InputEx
                            label="Invirizzo: Piazza / Via"
                            name="sedeLegale.indirizzoVia"
                            register={register}
                        />
                    </div>
                    <div className="sm1-6P">
                        <InputEx
                            label="Num. Civico"
                            name="sedeLegale.indirizzoNumero"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm2-6P">
                        <InputEx
                            label="Telefono"
                            name="sedeLegale.telefono"
                            register={register}
                            addOnBefore={<TelefonoButton telefono={resource.sedeLegale.telefono}/>}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Fax"
                            name="sedeLegale.fax"
                            register={register}
                            addOnBefore={<FaxButton fax={resource.sedeLegale.fax}/>}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            type="email"
                            label="Email"
                            name="sedeLegale.email"
                            register={register}
                            addOnBefore={<EmailButton email={resource.sedeLegale.email}/>}
                        />
                    </div>
                </div>

            </fieldset>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Contatto uso interno</legend>

                <div className="flexRowWrapFull !mt-0">
                    <div className="sm2-6P">
                        <InputEx
                            label="Telefono"
                            name="contatto.telefono"
                            register={register}
                            addOnBefore={<TelefonoButton telefono={resource.contatto ? resource.contatto.telefono : undefined}/>}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Fax"
                            name="contatto.fax"
                            register={register}
                            addOnBefore={<FaxButton fax={resource.contatto ? resource.contatto.fax : undefined}/>}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            type="email"
                            label="Email"
                            name="contatto.email"
                            register={register}
                            addOnBefore={<EmailButton email={resource.contatto ? resource.contatto.email : undefined}/>}
                        />
                    </div>
                </div>

            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>;
}
export default GeneralitaAziendaEditor;
